export default __webpack_public_path__ + "static/media/divadeniz5.340b942f.jpg";